import { useEffect, useRef, useState } from 'react';

const lines = [
  '> Operational status:    NOMINAL',
  '> Weekly operations:     1,592',
  '> Throughput last 7d:    8.6 MB',
  '> Failed executions:     0',
  '> Average latency:       412 ms',
  '> Documents processed:   3,240',
  '> Uptime, trailing 30d:  100.0%',
];

export default function FeatureTypewriter() {
  const [out, setOut] = useState<string[]>([]);
  const [typing, setTyping] = useState('');
  const lineIdx = useRef(0);
  const charIdx = useRef(0);

  useEffect(() => {
    let mounted = true;
    const tick = () => {
      if (!mounted) return;
      const line = lines[lineIdx.current];
      if (charIdx.current < line.length) {
        charIdx.current += 1;
        setTyping(line.slice(0, charIdx.current));
        setTimeout(tick, 22);
      } else {
        setOut((prev) => [...prev.slice(-5), line]);
        setTyping('');
        charIdx.current = 0;
        lineIdx.current = (lineIdx.current + 1) % lines.length;
        setTimeout(tick, 700);
      }
    };
    const start = setTimeout(tick, 400);
    return () => {
      mounted = false;
      clearTimeout(start);
    };
  }, []);

  return (
    <article className="grain group relative flex h-[420px] flex-col overflow-hidden rounded-4xl border border-white/10 bg-charcoal p-8">
      <div className="flex items-center justify-between">
        <p className="label">Telemetry · Live</p>
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-pulse-gold rounded-full bg-gold opacity-60" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-gold" />
        </span>
      </div>

      <h3 className="mt-6 font-display text-3xl font-light text-white">
        Production telemetry
      </h3>

      <div className="mt-6 flex-1 overflow-hidden rounded-2xl border border-white/5 bg-black/60 p-4">
        <pre className="font-mono text-[0.72rem] leading-6 text-white/90">
          {out.map((l, i) => (
            <div key={i} className="text-white/80">{l}</div>
          ))}
          <div className="text-gold">
            {typing}
            <span className="ml-0.5 inline-block h-3 w-1.5 animate-pulse bg-gold align-baseline" />
          </div>
        </pre>
      </div>
    </article>
  );
}
